import sanitizer from '@/services/html-sanitizer.service.js'

export const sanitizedHtml = {
  mounted(el, binding) {
    el.innerHTML = sanitizer.sanitize(binding.value)
  },
  updated(el, binding) {
    if (binding.value !== binding.oldValue) {
      el.innerHTML = sanitizer.sanitize(binding.value)
    }
  }
}
